/**
 * SF-T-144: a sub-task added in this browser that the server doesn't have yet. Kept in the browser
 * (UI_PREFS.tasksPendingSubtasks) until the server has it, so a failed save, a closed tab or a reload
 * never loses it. The id is chosen here: saving it again is safe, the server answers with the one it has.
 */
export interface PendingSubtask {
  id: string;
  title: string;
  /** When it was added (ISO). */
  at: string;
}

/** The stored list, keeping only well-formed entries. No imports: ui-prefs.ts reads it as it loads. */
export function parsePendingSubtasks(value: unknown): PendingSubtask[] | undefined {
  if (!Array.isArray(value)) return undefined;
  return value.filter(
    (v): v is PendingSubtask =>
      typeof v === 'object' && v !== null && typeof v.id === 'string' && typeof v.title === 'string' && typeof v.at === 'string'
  );
}

/** Which pending ones are left once the server's sub-tasks are known: saved ones drop out. */
export function unsavedSubtasks(pending: PendingSubtask[], savedIds: readonly string[]): PendingSubtask[] {
  return pending.filter((p) => !savedIds.includes(p.id));
}
